import type { Action } from 'redux';

import type { GetApiAirportResponse } from '/api/types.gen';
import normaliseError, { type NormaliseErrorInput } from '/shared/functions/normaliseError';
import type { NormalisedError } from '/index';

type AirportResponseItem = GetApiAirportResponse[number];

export type Airport = AirportResponseItem & {
  code: AirportResponseItem['iata_code'];
};

export interface AirportsState {
  items: Array<Airport> | null;
  fetching: boolean;
  fetched: boolean;
  token: string | null;
  error: NormalisedError | null;
}

interface AirportsFetchStartedAction extends Action {
  type: 'AIRPORTS_FETCH_STARTED';
}

interface AirportsFetchFulfilledAction extends Action {
  type: 'AIRPORTS_FETCH_FULFILLED';
  items: Array<Airport>;
  token?: string | null;
}

interface AirportsFetchRejectedAction extends Action {
  type: 'AIRPORTS_FETCH_REJECTED';
  error: NormaliseErrorInput;
}

type AirportsAction = AirportsFetchStartedAction | AirportsFetchFulfilledAction | AirportsFetchRejectedAction;

const defaultState: AirportsState = {
  items: null,
  fetching: false,
  fetched: false,
  token: null,
  error: null,
};

function reducer(state: AirportsState = defaultState, action: AirportsAction): AirportsState {
  switch (action.type) {
    case 'AIRPORTS_FETCH_STARTED': {
      return {
        ...state,
        fetching: true,
        error: null,
      };
    }
    case 'AIRPORTS_FETCH_FULFILLED': {
      if (!action.items) {
        return state;
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.items,
        token: action.token ?? null,
      };
    }
    case 'AIRPORTS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: normaliseError(action.error),
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
